<script setup lang="ts">
import { computed, onBeforeUnmount, onMounted } from 'vue'
import i18n from '~/i18n'
import { useSnackbarStore } from '~/store/snackbar'

const snackbarStore = useSnackbarStore()

const visible = computed(() => snackbarStore.visible)
const color = computed(() => snackbarStore.color)
const timeout = computed(() => snackbarStore.timeout)
const text = computed(() => snackbarStore.text)

onMounted(() => {
  const hideSnackbar = () => {
    snackbarStore.hideSnackbar()
  }

  const showSnackbarInfinity = () => {
    snackbarStore.showSnackbarInfinity({
      color: 'primary',
      text: i18n.t('OfflineMode.offline'),
    })
  }

  window.addEventListener('online', hideSnackbar)
  window.addEventListener('offline', showSnackbarInfinity)
})

onBeforeUnmount(() => {
  window.removeEventListener('online', () => { })
  window.removeEventListener('offline', () => { })
})
</script>

<template>
  <v-snackbar
    :color="color || 'primary'"
    :timeout="timeout || 600"
    :value="visible"
  >
    <v-row class="justify-center">
      <span class="text-h6">
        {{ text }}
      </span>
    </v-row>
  </v-snackbar>
</template>
